
var debug = false
var openDebug = function () {
    debug = true
}
var log = function (message) {
    if (typeof window !== 'undefined' && debug) {
        window.alert('wvjb: ' + message)
    }
}
var tryParseJSON = function (str) {
    if (typeof str === 'string') {
        try {
            return JSON.parse(str)
        } catch (e) {
            log('tryParseJSON error')
            return {}
        }
    }
    return str
}

// 支持jsbridge的UA列表，
var ua = [
    'MWYBrowser',
    'MWYSBrowser',
    'JGTBrowser',
    'MWYHaloveBrowser',
    'MWYF1Browser',
    'EAPBrowser',
    'MWYSLJBrowser',
    'MWYSCZYBrowser',
    'AIOBrowser',
    'MWYSTOREBrowser',
    'MDLIFE'
]

var device = {
    isBrowser: typeof navigator !== 'undefined'
}
if (device.isBrowser) {
    // 支持jsbridge的UA列表
    device.supportJsBridge = ua.some(function (value) {
        // return new RegExp(value).test(navigator.userAgent);
        // 不限制ua
        return true
    })
}

var _setWebViewJSBridgeV4 = function (callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
    }
    // 监听WebViewJavascriptBridgeReady事件，主要处理当前文件执行时，bridge还未注入的情况
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
        callback(window.WebViewJavascriptBridge)
    }, false)
}
var _setWebViewJSBridgeV6 = function (callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
    }
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
        callback(window.WebViewJavascriptBridge)
    }, false)
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    // 创建iframe，客户端接收到iframe请求时，注入jsbridge
    var WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function () { return document.documentElement.removeChild(WVJBIframe) }, 500)
}
var setWebViewJSBridge = function (callback) {
    // 获取Jsbridge版本
    var jsbridgeMajorVersion = /wvjb ([^.]+)/i.test(navigator.userAgent) ? RegExp.$1 : '4'
    log('wvjb v' + jsbridgeMajorVersion)
    // android客户端目前使用版本4，ios客户端使用版本6
    if (jsbridgeMajorVersion === '4') {
        _setWebViewJSBridgeV4(function (bridge) {
            bridge.init()
            callback(bridge)
        })
    } else if (jsbridgeMajorVersion === '6') {
        _setWebViewJSBridgeV6(callback)
    } else {
        log('错误的 webviewJavaScriptBridge 版本号')
    }
}

// bfCache兼容问题处理
// bfCache白名单，bfCache会导致部分api需要重新设置处理
var whiteList = ['showShareButton', 'hideShareButton', 'showOrHideBar',
    'setNavigationBarRightButtons', 'setPopupShareItems', 'setPopupMultifunctionItems']
// bfCache白名单映射表，调用了映射表方法会删除calledApi中bfCache白名单列表api
var whiteListMap = {
    resetNavigationBarRightButtons: 'setNavigationBarRightButtons',
    resetPopupShareItems: 'setPopupShareItems',
    resetPopupMultifunctionItems: 'setPopupMultifunctionItems',
    showShareButton: 'hideShareButton',
    hideShareButton: 'showShareButton'
}
// 记录调用bfCache白名单列表api参数和回调
var calledApi = {}
// 处理BfCache白名单方法
var handleBfCacheWhiteList = function (method, params, callback) {
    for (var i = 0; i < whiteList.length; i++) {
        if (whiteList[i] === method) {
            calledApi[method] = {
                params: params,
                cb: callback
            }
            break
        }
    }
    for (var key in whiteListMap) {
        if (key === method) {
            delete calledApi[whiteListMap[key]]
            break
        }
    }
}
var onPageshow = function (bridge) {
    // 监听pageshow，触发BfCache白名单方法
    window.addEventListener('pageshow', function (e) {
        if (e.persisted === true) {
            log('pageshow重置白名单方法')
            var _loop_1 = function (key) {
                var whiteListApi = calledApi[key] || {}
                bridge.callHandler(key, whiteListApi.params, function (response) {
                    var res = tryParseJSON(response)
                    typeof whiteListApi.cb === 'function' && whiteListApi.cb(res)
                    log('\u65B9\u6CD5' + key + '\u8FD4\u56DE\u6570\u636E\uFF1A' + JSON.stringify(res))
                })
            }
            for (var key in calledApi) {
                _loop_1(key)
            }
        }
    })
}

// 状态枚举
var Status;
(function (Status) {
    Status[Status['INIT'] = 0] = 'INIT'
    Status[Status['FINISH'] = 1] = 'FINISH'
})(Status || (Status = {}))
// 白名单方法才执行超时回调功能
var whiteList$1 = ['getLocationCoordinate']
// 超时定时器
var Timer = /** @class */ (function () {
    function Timer (options) {
        // 初始状态
        this.status = Status.INIT
        // 初始化参数
        this.options = options || { method: '' }
        // 默认超时时间为3s
        this.TIMEOUT = 3000
    }
    Timer.prototype.setTimeout = function (fn) {
        var _this = this
        // 不在白名单方法直接返回，不做超时处理
        if (whiteList$1.indexOf(this.options.method) < 0) {
            return
        }
        this.timer = setTimeout(function () {
            // 如果定时器结束状态还未改为finish，则执行回调函数
            if (_this.status !== Status.FINISH) {
                _this.finish()
                typeof fn === 'function' && fn()
            }
        }, this.TIMEOUT)
    }
    Timer.prototype.finish = function () {
        clearTimeout(this.timer)
        this.timer = null
        this.status = Status.FINISH
    }
    Timer.prototype.isFinish = function () {
        return this.status === Status.FINISH
    }
    return Timer
}())

var _bridge
// 客户端支持的api列表
var supportedAPIList = []
// 调用方法队列
var callMethodQueue = []
// h5注册方法队列
var registerMethodQueue = []
// 上一次调用bridge方法时间
var lastCallTime
// bridge方法延时调用时间
var WAIT_TIME = 80
var installBridge = function (bridge) {
    if (_bridge) {
        return
    }
    _bridge = bridge
    while (callMethodQueue.length) {
        callMethodQueue.shift()()
    }
    while (registerMethodQueue.length) {
        registerMethodQueue.shift()()
    }
    if (device.isBrowser) {
        onPageshow(bridge)
    }
}
var callMethod = function (method, data, success, error) {
    // 两次调用间隔小于80毫秒时，延时调用bridge方法
    if (lastCallTime && Date.now() - lastCallTime < WAIT_TIME) {
        setTimeout(function () {
            callMethod(method, data, success, error)
        }, WAIT_TIME)
        return
    }
    lastCallTime = Date.now()
    if (!_bridge) {
        return callMethodQueue.push(callMethod.bind(null, method, data, success, error))
    }
    // 初始化调用native方法超时定时器
    var timer = new Timer({ method: method })
    var _success = function (response) {
        var data = tryParseJSON(response)
        log('callMethod success: \n ' + JSON.stringify(data))
        if (typeof success === 'function' && !timer.isFinish()) {
            timer.finish()
            success(data)
        }
        // 处理bfCache白名单方法
        handleBfCacheWhiteList(method, data, success)
    }
    if (supportedAPIList.indexOf(method) > -1) {
        timer.setTimeout(error)
        return _bridge.callHandler(method, data, _success)
    }
    _bridge.callHandler('checkJsApi', [method], function (_supportedAPIList) {
        var apiList = tryParseJSON(_supportedAPIList)
        if (apiList instanceof Object && apiList[method]) {
            supportedAPIList.push(method)
            timer.setTimeout(error)
            _bridge.callHandler(method, data, _success)
        } else {
            log('callMethod ' + method + ' error')
            if (typeof error === 'function') {
                error()
            }
        }
    })
}
var registerMethod = function (method, callback) {
    if (!_bridge) {
        return registerMethodQueue.push(registerMethod.bind(null, method, callback))
    }
    _bridge.registerHandler(method, function (response) {
        var data = tryParseJSON(response)
        log('wvjb registerMethod callback: \n' + JSON.stringify(data))
        if (typeof callback === 'function') {
            callback(data)
        }
    })
}

var debug$1 = false
var initialized = false // 是否已初始化bridge
var eventEmitter = {
    // 储存 registerMethod 注册的方法，避免多次注册
    _events: {},
    openDebug: function () {
        debug$1 = true
        openDebug()
    },
    /**
     * 给 APP 发送消息
     * @param {String} event 事件名称
     * @param {Object} data 参数
     * @param {Function} success 成功的回调函数，用于 APP 返回数据给 H5，比如 getToken 方法
     * @param {Function} error 失败的回调函数，一般表示该方法不存在
     */
    emit: function (event, data, success, error) {
        callMethod(event, data, success, error)
    },
    /**
     * 监听 APP 消息
     * @param {String} event 事件名称
     * @param {Function} fn 回调函数
     */
    on: function (event, fn) {
        var _this = this
        if (event in this._events) {
            return this._events[event].push(fn)
        }
        this._events[event] = [fn]
        registerMethod(event, function (data) {
            _this._events[event].forEach(function (_fn) { return _fn(data) })
        })
    },
    /**
     * 监听 APP 消息，只会触发一次
     * @param {String} event 事件名称
     * @param {Function} fn 回调函数
     */
    once: function (event, fn) {
        var _this = this
        var _fn = function (data) {
            _this.off(event, _fn)
            fn(data)
        }
        this.on(event, _fn)
    },
    /**
     * 解除监听
     * @param {String} event 事件名称
     * @param {Function} fn 回调函数
     */
    off: function (event, fn) {
        var index = this._events[event].indexOf(fn)
        if (index > -1) {
            this._events[event].splice(index, 1)
        }
    }
}
function initBridge () {
    setWebViewJSBridge(function (_bridge) {
        log('initialized')
        if (device.isBrowser && debug$1) {
            window.bridge = _bridge
        }
        installBridge(_bridge)
        initialized = true
    })
}
function init () {
    if (device.supportJsBridge) {
        var times_1 = 0
        initBridge()
        // IOS的微医客户端，在从其他h5页面返回当前页面时，会出现bridge初始化失败问题。
        // 新增3次重试机制来解决初始化失败的问题。
        var timer_1 = setInterval(function () {
            if (initialized || times_1 >= 3) {
                clearInterval(timer_1)
                timer_1 = null
                return
            }
            window.WVJBCallbacks = null
            times_1++
            initBridge()
        }, 1000)
    }
}
init()

export default eventEmitter



// WEBPACK FOOTER //
// ./src/utils/bridge/wy-bridge.js